// Couleur d'accent unique de l'app (boutons, badges actifs, highlights).
// Les artistes n'ont PAS de couleur propre : une seule identite visuelle.
export const ACCENT_COLOR = '#f97316';

// Etat selectionne des panneaux de choix (Vue, Select Scale, Select Progression,
// transport du lecteur) : fond blanc, texte noir. Un seul signe de selection
// dans toute l'app, celui de la carte Play de la progression. Avant, chaque
// panneau avait sa teinte (orange pour les progressions, vert pour la tonique,
// bleu pour les gammes, violet pour la vue) : quatre codes a apprendre pour
// dire la meme chose, et aucun ne disait "c'est ceci qui est choisi" mieux que
// le contraste maximal.
export const SELECTED_BG = '#fff';
export const SELECTED_FG = '#000';
// Survol d'un element deja selectionne : il ne doit pas s'eteindre sous la
// souris, juste accuser le geste.
export const SELECTED_BG_HOVER = '#e9e9ec';
